<footer class="footer">
  <div class="footer__main container">
    <!-- brand: logo, tagline, contact -->
    <section class="footer__brand">
      <a [routerLink]="['/']" class="footer__logo-link">
        <img
          class="footer__logo-img"
          ngSrc="assets/icons/logo-wejoiner.svg"
          alt="Wejoiner"
          height="80"
          width="200" />
      </a>
      <p class="footer__tagline">{{ 'footer.tagline' | translate }}</p>
      <div class="footer__contact">
        <a
          [href]="companyPhoneTel"
          class="footer__contact-line footer__contact-line--ltr">
          <i class="iconsax footer__contact-icon" icon-name="phone"></i>
          <span>{{ companyPhoneDisplay }}</span>
        </a>
        <p class="footer__contact-line">
          <i class="iconsax footer__contact-icon" icon-name="location"></i>
          <span>{{ companyAddressKey | translate }}</span>
        </p>
      </div>
    </section>

    <!-- platform column -->
    <section class="footer__column">
      <h3 class="footer__column-title">{{ 'footer.platform' | translate }}</h3>
      <ul class="footer__links">
        @for (page of platformPages; track page.id) {
          <li>
            <a [routerLink]="page.link" class="footer__link">{{
              page.name | translate
            }}</a>
          </li>
        }
      </ul>
    </section>

    <!-- company column -->
    <section class="footer__column">
      <h3 class="footer__column-title">{{ 'footer.company' | translate }}</h3>
      <ul class="footer__links">
        @for (page of companyPages; track page.id) {
          <li>
            <a [routerLink]="page.link" class="footer__link">{{
              page.name | translate
            }}</a>
          </li>
        }
      </ul>
    </section>

    <!-- legal & compliance — two sub-columns -->
    <section class="footer__column footer__column--legal">
      <h3 class="footer__column-title">
        {{ 'footer.legal.heading' | translate }}
      </h3>
      <div class="footer__legal-columns">
        <ul class="footer__links">
          @for (page of legalColumnPrimary; track page.id) {
            <li>
              <a [routerLink]="page.link" class="footer__link">{{
                page.name | translate
              }}</a>
            </li>
          }
        </ul>
        <ul class="footer__links">
          @for (page of legalColumnSecondary; track page.id) {
            <li>
              <a [routerLink]="page.link" class="footer__link">{{
                page.name | translate
              }}</a>
            </li>
          }
        </ul>
      </div>
    </section>
  </div>

  <div class="footer__divider"></div>

  <div class="footer__bottom container">
    <div class="footer__bottom-info">
      <p class="footer__copyright">{{ 'footer.copyright' | translate }}</p>
      <p class="footer__registered">
        {{ 'footer.registeredNotice' | translate }}
      </p>
    </div>
    <nav class="footer__social" aria-label="Social media">
      @for (social of socialMedias; track social.id) {
        <a
          [href]="social.link"
          class="footer__social-link"
          [attr.aria-label]="social.title"
          target="_blank"
          rel="noopener noreferrer">
          <img
            [ngSrc]="social.icon"
            [alt]="social.title"
            width="18"
            height="18" />
        </a>
      }
    </nav>
  </div>
</footer>
